import { createLucideIcon } from 'lucide-react';
export const GlobeSolidIcon = createLucideIcon('globe-solid-icon', [
  [
    'path',
    {
      d: 'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z',
      key: '139h8e',
    },
  ],
  [
    'path',
    {
      d: 'M12 2C9.43223 4.69615 8 8.27674 8 12C8 15.7233 9.43223 19.3038 12 22C14.5678 19.3038 16 15.7233 16 12C16 8.27674 14.5678 4.69615 12 2Z',
      key: 'tlibtd',
    },
  ],
  [
    'path',
    {
      d: 'M2 12H22',
      key: '1m8cig',
    },
  ],
]);
